import React, { useEffect } from 'react'
import Form from './Form'
import { Review } from '../../components'
import { reviewData } from '../../dummyData'
import { Helmet } from 'react-helmet'


const ContactUs = () => {

  useEffect(() => {

    window.scrollTo(0, 0)

  }, [])

  return (
    <div>

      <Helmet >
        <title>CodeZone | Contact Us</title>
      </Helmet>

      <div className='bg-gray-50 dark:bg-slate-800 transition-all duration-700'>
        <div className='max-w-screen-2xl pt-[52px] md:pt-[70px] w-[90%] mx-auto md:w-full'>
          <div className='py-10 md:px-4'>
            <Form />
          </div>
        </div>
      </div>
      <div className='dark:bg-gray-900 transition-all duration-700'>
        <Review data={reviewData} />
      </div>

    </div>
  )
}

export default ContactUs